import React, { useEffect, useState } from "react";
import Happypatient from "../../Assets/hero/happy Patient/friends.gif";
import cities from "../../Assets/hero/happy Patient/gps.gif";
import award from "../../Assets/hero/happy Patient/medal-.gif";
import Associated from "../../Assets/hero/happy Patient/stethoscope.gif";
import Loading from "../../Shared/Loading";

const State = () => {
  const [user, setUser] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useState(() => {
    fetch("https://servercareseebd.careseebd.com/api/v1/user", {
      headers: {
        authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
      },
    }).then((res) => res.json().then((data) => setUser(data?.data)));
  }, []);

  useEffect(() => {
    setLoading(true);
    fetch(`https://servercareseebd.careseebd.com/api/v1/homeState/getHomeState`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data.length) {
          setData(data?.data[0]);
        }
      });
    setLoading(false);
  }, []);

  if (loading) {
    return <Loading />;
  }
  const patient = user?.filter((u) => u.role === "user");
  const doctor = user?.filter((u) => u.role === "doctor");
  return (
    <div className=" py-20 bg-bgColor text-white flex justify-center items-center w-full">
      <div className=" lg:w-10/12 w-11/12  mx-auto grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 lg:gap-10 gap-5">
        <div className="  py-4 bg-white text-black  rounded-md flex flex-col justify-center items-center text-center ">
          <img
            className="w-36"
            src={Happypatient}
            alt=""
            style={{
              animation: "rotate 5s linear infinite",
            }}
          />
          <h1 className="mt-2 text-secondary font-semibold ">HappyPatient</h1>
          <p className="mt-1 text-lg font-bold">{patient?.length}+</p>
        </div>

        <div className=" py-4 bg-white text-black rounded-md flex flex-col  justify-center items-center text-center ">
          <div className=" p-5 ">
            <img className="w-28" src={Associated} alt="" />
            <h1 className=" w-full text-secondary font-semibold ">Associated Doctors</h1>
            <p className=" mt-1 text-lg font-bold">{doctor?.length}+</p>
          </div>
        </div>

        <div className=" py-4 bg-white text-black  rounded-md flex flex-col justify-center  items-center text-center">
          <div className="p-5">
            <img className="w-28 " src={cities} alt="" />

            <h1 className="mt-2 text-secondary font-semibold">Cities</h1>
            <p className="mt-1 text-lg font-bold">{data?.city}+</p>
          </div>
        </div>

        <div className="  py-4 bg-white text-black rounded-md flex flex-col justify-center items-center text-center">
          <div className=" ">
            <img className="p-5 w-36" src={award} alt="" />

            <h1 className=" mt-2 text-secondary font-semibold">Awards</h1>
            <p className=" mt-1 text-lg font-bold">{data?.awards}+</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default State;
